import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  Stack,
  Typography,
  Paper,
  Button,
  Alert,
  Box,
  CircularProgress
} from '@mui/material';
import { useCreateEntryMutation } from '../hooks/useFirebaseQueries';
import EntryForm from '../components/forms/EntryForm';

const AddSingleEntryPage = () => {
  const navigate = useNavigate();
  const createEntryMutation = useCreateEntryMutation();

  const form = useForm({
    defaultValues: {
      name: '',
      breed: '',
      sex: '',
      notes: {
        active: '',
        archived: []
      },
      characteristics: [],
      phase: '',
      species: '',
      mother: '',
      father: '',
      isFavorited: false,
      isFoundation: false
    }
  });

  const onSubmit = async (data) => {
    if (typeof data.breed !== Array) {
      data.breed = [data.breed]
    }
    const entryId = await createEntryMutation.mutateAsync({
      formData: data,
      attachments: [] // Handle file uploads separately
    });

    console.log('formData', data)
    navigate(`/entry/${entryId}`);
  };

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <Box>
          <Typography variant="h4" component="h2">
            Add New Entry
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Add a single bird to your flock
          </Typography>
        </Box>
      </Box>

      <Paper sx={{ p: 3 }} variant="outlined">
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Stack spacing={3}>
            <EntryForm form={form} />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => navigate('/flock-manager')}
                disabled={createEntryMutation.isPending}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                disabled={createEntryMutation.isPending}
                startIcon={
                  createEntryMutation.isPending ? (
                    <CircularProgress size={20} />
                  ) : null
                }
              >
                {createEntryMutation.isPending ? 'Saving...' : 'Save Entry'}
              </Button>
            </Box>

            {createEntryMutation.error && (
              <Alert severity="error">
                Error saving entry: {createEntryMutation.error.message}
              </Alert>
            )}
          </Stack>
        </form>
      </Paper>
    </Stack>
  );
};

export default AddSingleEntryPage;
